import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { RootStoreState } from 'src/app/store';

import { DocumentEndorsementLocation } from '../../models';
import { EndorsementsSelectors } from '../../store';

@Component({
    selector: 'app-endorsement-flag',
    templateUrl: './endorsement-flag.component.html',
    styleUrls: ['./endorsement-flag.component.scss'],
    standalone: false
})
export class EndorsementFlagComponent implements OnInit, OnDestroy {
  @Input() endorsementId: number;
  @Input() currentPackageUserId: string;
  @Input() documentScale: number;

  @HostBinding('style.top.px') public get yPosition(): number {
    const flagOffset = 8;

    return this.endorsementLocation
      ? this.endorsementLocation.yPosition * this.documentScale - flagOffset
      : null;
  }

  endorsementLocation: DocumentEndorsementLocation;
  notifier = new Subject();

  constructor(private readonly store: Store<RootStoreState.State>) {}

  ngOnInit(): void {
    this.store
      .pipe(
        select(EndorsementsSelectors.selectEndorsementLocationById, {
          endorsementLocationId: this.endorsementId,
        }),
        tap((endorsementLocation) => (this.endorsementLocation = endorsementLocation))
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.notifier.next(undefined);
    this.notifier.complete();
  }
}
